// @flow
import React from "react";
import Container from "@material-ui/core/Container";
import { GameDetailsProps } from "./GameDetails";
import formatDates from "../../common/formatDates";
import GameDetailsHeader from "./GameDetailsHeader";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AccessTimeIcon from "@material-ui/icons/ScheduleTwoTone";
import EventTwoToneIcon from "@material-ui/icons/EventTwoTone";
import TodayIcon from "@material-ui/icons/CalendarTodayTwoTone";
import PeopleAltTwoToneIcon from "@material-ui/icons/PeopleAltTwoTone";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import gameSelectors from "../../selectors/gameSelectors";
import GameDetailsFooter from "./GameDetailsFooter";
import LocationListItem from "../../components/LocationListItem";
import GameDetailsContentResults from "./GameDetailsContentResults";

type Props = GameDetailsProps & {
  open: boolean,
  onClose: Function,
  onOpen: Function,
};

function GameDetailsContent({
  game,
  team,
  opponent,
  location,
  isMatchday,
  ticketReservationStatus,
  type,
}: Props) {
  const { leftTeam, rightTeam } = gameSelectors.getLeftAndRightTeams(
    game,
    team,
    opponent
  );

  return (
    <Container maxWidth="sm">
      <div
        style={{
          margin: "0 auto",
          width: 36,
          height: 5,
          backgroundColor: "#C4C4C4",
          borderRadius: 3,
          marginTop: 7,
          marginBottom: 7,
        }}
      />
      <GameDetailsHeader leftTeam={leftTeam} rightTeam={rightTeam} />
      <List>
      {type === "RESULT" ? <GameDetailsContentResults game={game} /> : null}
        <ListItem>
          <ListItemIcon>
            {isMatchday ? <TodayIcon /> : <EventTwoToneIcon />}
          </ListItemIcon>
          <ListItemText primary={formatDates.prettyDate(game.date)} />
        </ListItem>
        <Divider component="li" />
        <ListItem>
          <ListItemIcon>
            <AccessTimeIcon />
          </ListItemIcon>
          <ListItemText
            primary={formatDates.dayAndTime(game.date)}
            secondary={
              game.isHomegame &&
              type !== "RESULT" &&
              `Stream startet um ${moment(game.date)
                .subtract(30, "minutes")
                .format("HH:mm")} Uhr`
            }
          />
        </ListItem>
        <Divider component="li" />
        <LocationListItem gameId={game.id} />
        {type !== "RESULT" && (
          <>
            <Divider component="li" />
            <ListItem>
              <ListItemIcon>
                <PeopleAltTwoToneIcon />
              </ListItemIcon>
              {ticketReservationStatus === "NONE" ? (
                <ListItemText
                  primary={
                    <Typography color="textSecondary" variant="body2">
                      Bitte informiere dich vor deiner Anreise beim Gastgeber,
                      ob und unter welchen Bedingungen Zuschauer erlaubt sind.
                    </Typography>
                  }
                />
              ) : (
                <>
                  <ListItemText
                    primary={
                      <Typography color="textSecondary" variant="body2">
                        Aufgrund der steigenden Corona-Fälle sind keine
                        Zuschauer möglich – deshalb haben wir einen Live-Stream
                        für euch eingerichtet.
                      </Typography>
                    }
                  />
                  {/* <ListItemText primary="Eintritt" secondary="3€ pro Person" /> */}
                </>
              )}
            </ListItem>
          </>
        )}
        {type !== "RESULT" && (
          <GameDetailsFooter
            location={location}
            ticketReservationStatus={ticketReservationStatus}
            game={game}
          />
        )}
      </List>
      <div
        style={{
          height: 1,
          marginBottom: `env(safe-area-inset-bottom)`,
        }}
      />
    </Container>
  );
}

export default GameDetailsContent;
